export default "__VITE_PUBLIC_ASSET__01252e50__"